import { HYDRATE } from 'next-redux-wrapper';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { TFormAction, TFormEntity } from '~/src/features/lk/components/ContactForm/types';
import {
    EContactAlertActions,
    IAlertContact,
    IAlertData,
    IResultState,
    TResetState,
    TSetAction,
    TSetAlertData,
    TSetCodeVerificationError,
    TSetContact,
    TSetEntity,
    TSetIsFetchingCode,
    TSetIsShowPopup,
    TSetIsVerifyingCode,
    TSetResult,
} from '~/src/features/lk/popups/ContactPopup/store/actionCreators';
import { THydrateAction } from '~/src/store';

export type { TFormAction } from '~/src/features/lk/components/ContactForm/types';
export type { TFormEntity } from '~/src/features/lk/components/ContactForm/types';

export interface IContactAlertState {
    isShowPopup: boolean,
    isFetchingCode: boolean,
    isVerifyingCode: boolean,
    action: TFormAction | null,
    entity: TFormEntity,
    alertData: IAlertData,
    contact: IAlertContact,
    codeVerificationError: string,
    result: IResultState,
}

export const initialState: IContactAlertState = {
    isShowPopup: false,
    isFetchingCode: false,
    isVerifyingCode: false,
    action: null,
    entity: 'phone',
    alertData: {
        info: '',
        confirmButtonText: '',
    },
    contact: {
        value: '',
    },
    codeVerificationError: '',
    result: {
        isOpen: false,
        type: EResultPopupStatus.DEFAULT,
        title: '',
    },
};

export type TContactAlertActions =
    | TSetAction
    | TSetAlertData
    | TSetCodeVerificationError
    | TSetContact
    | TSetEntity
    | TSetIsFetchingCode
    | TSetIsShowPopup
    | TSetIsVerifyingCode
    | TSetResult
    | TResetState

const contactAlertReducer = (state = initialState, action: TContactAlertActions | THydrateAction): IContactAlertState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state };
        case EContactAlertActions.SET_ACTION:
            return {
                ...state,
                action: action.payload,
            };
        case EContactAlertActions.SET_ALERT_DATA:
            return {
                ...state,
                alertData: action.payload,
            };
        case EContactAlertActions.SET_CONTACT:
            return {
                ...state,
                contact: action.payload,
            };
        case EContactAlertActions.SET_ENTITY:
            return {
                ...state,
                entity: action.payload,
            };
        case EContactAlertActions.SET_IS_SHOW_POPUP:
            return {
                ...state,
                isShowPopup: action.payload,
            };
        case EContactAlertActions.SET_IS_FETCHING_CODE:
            return {
                ...state,
                isFetchingCode: action.payload,
            };
        case EContactAlertActions.SET_IS_VERIFYING_CODE:
            return {
                ...state,
                isVerifyingCode: action.payload,
            };
        case EContactAlertActions.SET_CODE_VERIFICATION_ERROR:
            return {
                ...state,
                codeVerificationError: action.payload,
            };
        case EContactAlertActions.SET_RESULT:
            return {
                ...state,
                result: action.payload,
            };
        case EContactAlertActions.RESET_STATE:
            return initialState;
        default:
            return state;
    }
};

export default contactAlertReducer;
